import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const ocActiveMenuItemState = atom({
  key: "ocActiveMenuItemState",
  default: "",
  effects_UNSTABLE: [ocPersistAtom],
});
